import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.blue};
  height: 100vh;
`;
